exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa {\r\n    font-size: 20px;\r\n    color:#31b34a;\n}\n.concept-label {\r\n  font-weight: normal;\r\n  color:#31b34a;\r\n  font-size: 16px;\n}\nlabel:hover{\r\n  color:#007bff;\r\n  text-decoration: underline;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-592f7c56","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ClassTree.vue
// module id = YBS8
// module chunks = 1